namespace JupitersChoice {
    export class StopLogoSheenCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        
        execute(): void {
            this._componentManager.get('BaseGameLogo').pause();
        }
    }
}